import { useEffect, useState } from "react";
import { Header, Loader,Modal } from "../components/index";
import { logEvent } from "../analytics/AnalyticsEvent";
import { AvatarList } from "../components/index";
import config, { getHeaders } from "../config";
import { useCallContext } from "../callContext/callContext";
import axios from "axios";
import { useMainContext } from "../callContext/MainContext";
import { useNavigate } from "react-router-dom";
import { isFacebookCampaign } from "../utils/Helpers";
import { SendGuiDataEvents } from "../commonScript";
const Home = () => {
  const {showModal,setShowModal}=useCallContext();
  const {language}=useMainContext();
  const navigate=useNavigate();
  const [uid,setUid] = useState(localStorage.getItem("uid") || null);
  const [data, setData] = useState([]);
  const [voicesData, setVoicesData] = useState([]);
  const [ambiencesData, setAmbiencesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message,setMessage]=useState("");
  const [tabChanged, setTabChanged] = useState(false);

  const tabs = [
    { id: 1, tabName:  {
      en:"Voices",
      fr:"Voix"
    }},
    { id: 2, tabName: {
      en:"Ambiences",
      fr:"Ambiances"
    }},
  ];
  const [currentTab, setCurrentTab] = useState(tabs?.[0]?.tabName?.[language]);
  const getConfigData = async () => {
    setLoading(true);
    const url = `${config.get("base")}${config.get("appConfig")}`;
    const headers={
      ...getHeaders(),
       Language:language,
       camp : sessionStorage.getItem("campId"),
       rcid : sessionStorage.getItem("rcid")
    }
    await axios({ method: "POST", url: url, headers: headers })
      .then((result) => {
        console.log("result message appConfig ::", result);
        if (result?.data?.status?.toUpperCase() === "SUCCESS") {
          const { appData } = result.data;
          const { calloVoices, calloAmbiences, app_configurations } = appData;
          console.log("appData ::", appData);
          setAmbiencesData(calloAmbiences);
          setData(calloVoices);
          setVoicesData(calloVoices);
          localStorage.setItem(
            "subscribeBtnText",
            JSON.stringify(app_configurations?.subscribe_btn_text)
          );
          localStorage.setItem(
            "unsubscribeBtnText",
            JSON.stringify(app_configurations?.unsubscribe_btn_text)
          );
          localStorage.setItem(
            "unsubscribe_alert_msg",
            JSON.stringify(app_configurations?.unsubscribe_alert_msg)
          );
          localStorage.setItem("ambienceShortCode",
          JSON.stringify(app_configurations?.ambienceShortCode));
          localStorage.setItem("voiceShortCode",
          JSON.stringify(app_configurations?.magicVoiceShortCode))
          checkSub();
        }
      })
      .catch((error) => {
        console.log("error is:::", error);
      });
  };
  useEffect(() => {
    let guiPlayEvents = {};
    guiPlayEvents["w_action"] = "homepage";
    SendGuiDataEvents(guiPlayEvents);
    getConfigData();
    return ()=>
    {
      setLoading(false)
    }
  }, []);

  const checkSub = async () => {
    //facebook campaign users are always active, no checkSub needed
    //but they still go through HE once (handled on packs page) to get msisdn
    if (isFacebookCampaign()) {
      if (!localStorage.getItem("msisdn") && !localStorage.getItem("hasHeRequestDone")) {
        navigate("/subs/packs");
        return;
      }
      setLoading(false);
      return;
    }
    //checkSub api events for request
    if (uid && uid!=="undefined" && uid!==undefined) {
      console.log("Checksub from home")
      logEvent(
        {
          screen: "home",
          event: "sub_api_request",
        },
        {
          title: "sub_api_request",
          userId: uid ? uid : "NA",
          others: {
            date: new Date(),
          },
        }
      );
      const url = `${config.get("base")}${config.get("checkSub")}`;
      console.log("headers are::",config.get('headers'))
      const headers=
      {
        ...getHeaders(),
        Language:language,
        camp : sessionStorage.getItem("campId"),
        rcid : sessionStorage.getItem("rcid")
      };
      await axios
        .post(url, { uid: uid }, {headers:headers})
        .then((result) => {
          console.log("checkSub api :::", result);
          setMessage(result?.data?.message);
          
          logEvent(
            {
              screen: "home",
              event: "sub_api_response",
            },
            {
              title: "sub_api_response",
              userId: uid ? uid : "NA",
              others: {
                status: result?.data?.subStatus,
                date: new Date(),
              },
            }
          )
          setLoading(false)
          localStorage.setItem("msisdn", result?.data?.msisdn);
          if(result?.data?.status==="success")
            {
          localStorage.setItem("displayStatus", result?.data?.status_display);
          localStorage.setItem("subStatus", result?.data?.subStatus);      
          localStorage.setItem("validity", result?.data?.validity);
          if(result?.data?.subStatus?.toLowerCase()==="active")
            {
              navigate("/home")
            }
          
          else if(result?.data?.subStatus?.toLowerCase()==="grace")
          {
              setShowModal(true);
          }
          else
          {
            navigate("/subs/packs");
          }
        }
       else
      {
        console.log("Status got failed")
        if(result?.data?.subStatus?.toLowerCase()==='new')
          {
            localStorage.setItem("initialState", result?.data?.subStatus);
          }
        navigate("/subs/packs");
      }
    }
  )
        .catch((error) => {
          console.log(error);
        });
      console.log("the data is:::", data);
    } else {
      console.log("No uid is present");
      navigate("/subs/packs");
      // fetchData();
    }
  };

  useEffect(() => {
    setTabChanged(true);
    const timeout = setTimeout(() => {
      setTabChanged(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [currentTab]);

  if (loading) return <Loader />;

  return (
    <>
      <Header />
      <div className="fixed custom-gray top-16 max-w-[500px] -mt-1 w-full z-[500] card-shadow ">
        <div className="grid grid-cols-2">
          {tabs.map((item) => (
            <div
              key={item.id}
              className={`py-4 flex justify-center items-center px-8 cursor-pointer  ${
                currentTab !== item?.tabName?.[language] ? "" : "bg-black/20"
              }`}
              onClick={() => {
                setCurrentTab(item?.tabName?.[language]);
                setData(item?.tabName?.[language] == "Voices" ? voicesData : ambiencesData);
              }}
            >
              <label
                className={`uppercase    cursor-pointer ${
                  currentTab !== item?.tabName?.[language]
                    ? "grey-theme-color"
                    : "text-black font-bold  "
                } `}
              >
                {item?.tabName?.[language]}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="min-h-screen">
        {showModal && <Modal showModel={showModal} setShowModel={setShowModal} reason={message} setLoading={setLoading}/>}
        {!tabChanged ? <AvatarList data={data} loading={loading} setLoading={setLoading}/> : <Loader />}
      </div>
    </>
  );
};

export default Home;
